import type { GeoLightingManager } from '../geo-lighting-manager.class';
import { updateLightingCfn } from './update-lighting.cfn';

/**
 * Start realtime update interval
 */
export const startRealtimeUpdatesCfn = (
	self: GeoLightingManager
): ReturnType<typeof setInterval> => {
	// Update every minute for realtime mode
	return setInterval(() => {
		if (self.isEnabled) {
			updateLightingCfn(self);
		}
	}, 60000); // 1 minute
};

/**
 * Stop realtime update interval
 */
export const stopRealtimeUpdatesCfn = (
	interval: ReturnType<typeof setInterval> | null
): void => {
	if (interval) {
		clearInterval(interval);
	}
};
